<template>
  <div
    class="bg-bg-empty border-border-empty relative h-4 w-20 overflow-hidden rounded-2xl border-2 transition-all duration-200"
  >
    <div
      class="bg-fill-positive absolute top-0 left-0 h-full transition-all duration-200"
      :style="{ width: positive() * 100 + '%' }"
    ></div>
    <div
      class="bg-fill-amazing absolute top-0 left-0 h-full transition-all duration-200"
      :style="{ width: amazing() * 100 + '%' }"
    ></div>
    <div
      v-if="!props.hideLines"
      class="bg-border-empty absolute top-0 h-full w-0.5"
      :style="{ left: (100 / max()) * i + '%' }"
      v-for="i in max() - 1"
    ></div>
    <div
      class="font-outline-1 font-fredoka absolute top-0 left-0 h-full w-full text-center text-2xl text-gray-100 drop-shadow"
    >
      {{ label }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps(['value', 'max', 'label', 'hideLines']);

const max: () => number = () => props.max;
const positive: () => number = () => Math.max(0, Math.min(props.value / props.max, 1));
const amazing: () => number = () => Math.max(0, Math.min(props.value / props.max - 1, 1));
</script>
